import { TAction, TBoundAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export const enum actionTypes {
  SET_RACE_VISUALIZER_DATA = 'RACE_VISUALIZER/SET_DATA',
  SHOW_RACE_VISUALIZER_SPINNER = 'RACE_VISUALIZER/SHOW_SPINNER',
  FORCE_RACE_VISUALIZER_REFRESH = 'RACE_VISUALIZER/FORCE_REFRESH'
}

type TSetWorldFirstTrackerPayload = {
  instanceId: string;
  data: any;
};

type TShowLoadingSpinnerPayload = {
  instanceId: string;
  show: boolean;
};

type TForceRefreshPayload = {
  instanceId: string;
};

export type TRaceVisualizerActions =
  | TBoundAction<actionTypes.SET_RACE_VISUALIZER_DATA, TSetWorldFirstTrackerPayload>
  | TBoundAction<actionTypes.SHOW_RACE_VISUALIZER_SPINNER, TShowLoadingSpinnerPayload>
  | TBoundAction<actionTypes.FORCE_RACE_VISUALIZER_REFRESH, TForceRefreshPayload>;

// Action Creators
const RaceVisualizerActions = {
  setWorldFirstTracker(instanceId: string, data: any): TAction<TSetWorldFirstTrackerPayload> {
    return {
      type: actionTypes.SET_RACE_VISUALIZER_DATA,
      payload: {
        instanceId,
        data
      }
    };
  },
  showLoadingSpinner(instanceId: string, show: boolean): TAction<TShowLoadingSpinnerPayload> {
    return {
      type: actionTypes.SHOW_RACE_VISUALIZER_SPINNER,
      payload: {
        instanceId,
        show
      }
    };
  },
  forceRefresh(instanceId: string): TAction<TForceRefreshPayload> {
    return {
      type: actionTypes.FORCE_RACE_VISUALIZER_REFRESH,
      payload: {
        instanceId
      }
    };
  }
};

export default RaceVisualizerActions;
